export default __webpack_public_path__ + "static/why-ml-10--mobile-bb9ba244702a254f165282b1337b9343.png";